import { useTranslation } from 'react-i18next';

import styles from './FreePlayWaitingForPick.module.css';

/**
 * Gamepad screen shown to every player EXCEPT the first-connected one while no game
 * has been picked yet. Prevents several phones from choosing the first game at the
 * same time (confusing). Once the first player picks, everyone follows into the game.
 */
export function FreePlayWaitingForPick() {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            <div className={styles.spinner} />
            <p className={styles.title}>{t('gamepad.freePlay.waiting.title')}</p>
            <p className={styles.subtitle}>{t('gamepad.freePlay.waiting.subtitle')}</p>
        </div>
    );
}
